import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const FullFamilyIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2220_9854)">
          <path
            d="M18.8688 13.009C21.1202 12.2801 23.6054 13.7429 24.0621 16.0649C24.8483 20.0619 25.294 25.2626 22.4439 30.199C19.2704 35.6958 15.1773 37.0582 11.0159 37.8992C9.04036 38.2985 7.02059 37.1414 6.39239 35.2263C5.14142 31.4126 4.24714 26.841 7.34227 21.4801C10.2647 16.4182 14.8725 14.3027 18.8688 13.009Z"
            fill="#FFEFCC"
          />
          <path
            d="M20 18.3333C23.6819 18.3333 26.6667 15.3486 26.6667 11.6667C26.6667 7.98477 23.6819 5 20 5C16.3181 5 13.3333 7.98477 13.3333 11.6667C13.3333 15.3486 16.3181 18.3333 20 18.3333Z"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 35V31.6667C10 29.8986 10.7024 28.2029 11.9526 26.9526C13.2029 25.7024 14.8986 25 16.6667 25H23.3333C25.1014 25 26.7971 25.7024 28.0474 26.9526C29.2976 28.2029 30 29.8986 30 31.6667V35"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30 5.21667C31.434 5.58384 32.7051 6.41784 33.6127 7.58719C34.5204 8.75654 35.0131 10.1947 35.0131 11.675C35.0131 13.1553 34.5204 14.5935 33.6127 15.7628C32.7051 16.9322 31.434 17.7662 30 18.1333"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.3333 35V31.6667C38.3249 30.1953 37.8299 28.768 36.9255 27.6073C36.021 26.4467 34.7581 25.6178 33.3333 25.25"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.33334 36.4167V33.0833C3.3418 31.6119 3.83682 30.1847 4.74123 29.024C5.64564 27.8633 6.90863 27.0345 8.33334 26.6667"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2220_9854">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
